export default {
  search: '/api/search',

  // reservation flow
  faq: `/api/:lang/faq`,
  home: `/api/:lang/home`,
  fleet: '/api/mft/vehicles',
  blog: `/api/:lang/blog/:blog`,
  aboutUs: `/api/:lang/about-us`,
  staticTexts: `/api/static-texts`,
  welcome: `/api/:lang/welcome-page`,
  contactUs: `/api/:lang/contact-us`,
  termsOfUse: `/api/:lang/terms-of-use`,
  edit: `/api/:lang/find-a-reservation`,
  cookiePolicy: `/api/:lang/cookie-policy`,
  terms: `/api/:lang/terms-and-conditions`,
  privacyPolicy: `/api/:lang/privacy-policy`,
  location: `/api/:lang/location/:location`,
  oneWayRentals: `/api/:lang/one-way-rentals`,
  reserveNow: `/api/:lang/alamo/reservation/reserve-now`,
  cancelReservation: `/api/:lang/alamo/reservation/cancel`,
  modifyReservation: `/api/:lang/alamo/reservation/modify`,
  getReservation: `/api/:lang/alamo/reservation/reservation`,
  selectVehicle: `/api/:lang/alamo/reservation/select-vehicle`,
  startReservation: `/api/:lang/alamo/reservation/start-reservation`,
  flightEndpoint:
    'https://prd-east.webapi.enterprise.com/enterprise-ewt/location/1042894?type=return',
  searchEndpoint: `https://search.location.enterprise.com/v1/search/location/${process.env.NEXT_PUBLIC_BRAND}/web/text/:keyword`,
} as const
